/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUserNameDTO,
    AcademicUserNameDTOFromJSON,
    AcademicUserNameDTOFromJSONTyped,
    AcademicUserNameDTOToJSON,
} from './AcademicUserNameDTO';
import {
    DisciplineCategoryEnum,
    DisciplineCategoryEnumFromJSON,
    DisciplineCategoryEnumFromJSONTyped,
    DisciplineCategoryEnumToJSON,
} from './DisciplineCategoryEnum';
import {
    EvaluationTypeEnum,
    EvaluationTypeEnumFromJSON,
    EvaluationTypeEnumFromJSONTyped,
    EvaluationTypeEnumToJSON,
} from './EvaluationTypeEnum';
import {
    IndicatorTypeEnum,
    IndicatorTypeEnumFromJSON,
    IndicatorTypeEnumFromJSONTyped,
    IndicatorTypeEnumToJSON,
} from './IndicatorTypeEnum';
import {
    Laboratory,
    LaboratoryFromJSON,
    LaboratoryFromJSONTyped,
    LaboratoryToJSON,
} from './Laboratory';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface SubjectDTO
 */
export interface SubjectDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    orderNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    nameRO?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    nameEN?: string | null;
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof SubjectDTO
     */
    status?: SubjectStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDTO
     */
    isPartiallySaved?: boolean;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof SubjectDTO
     */
    formativeCategory?: IndicatorTypeEnum;
    /**
     * 
     * @type {IndicatorTypeEnum}
     * @memberof SubjectDTO
     */
    subjectCategory?: IndicatorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    credits?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    creditsIIS?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    creditsOE?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    planYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    courseWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    labWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    seminarWeeklyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    projectWeeklyHours?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDTO
     */
    labAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDTO
     */
    seminarAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDTO
     */
    projectAtPartner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectDTO
     */
    practiceAtPartner?: boolean;
    /**
     * 
     * @type {EvaluationTypeEnum}
     * @memberof SubjectDTO
     */
    evaluationType?: EvaluationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    planDepartmentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    selfStudyHours?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    tutoringHours?: number;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof SubjectDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof SubjectDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {Array<Laboratory>}
     * @memberof SubjectDTO
     */
    laboratories?: Array<Laboratory> | null;
    /**
     * 
     * @type {Array<AcademicUserNameDTO>}
     * @memberof SubjectDTO
     */
    courseCoordinators?: Array<AcademicUserNameDTO> | null;
    /**
     * 
     * @type {Array<AcademicUserNameDTO>}
     * @memberof SubjectDTO
     */
    labCoordinators?: Array<AcademicUserNameDTO> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectDTO
     */
    learnings?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectDTO
     */
    eafsgAreas?: Array<string> | null;
    /**
     * 
     * @type {DisciplineCategoryEnum}
     * @memberof SubjectDTO
     */
    disciplineCategory?: DisciplineCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    practiceTotalHours?: number;
}

export function SubjectDTOFromJSON(json: any): SubjectDTO {
    return SubjectDTOFromJSONTyped(json, false);
}

export function SubjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'nameRO': !exists(json, 'nameRO') ? undefined : json['nameRO'],
        'nameEN': !exists(json, 'nameEN') ? undefined : json['nameEN'],
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
        'isPartiallySaved': !exists(json, 'isPartiallySaved') ? undefined : json['isPartiallySaved'],
        'formativeCategory': !exists(json, 'formativeCategory') ? undefined : IndicatorTypeEnumFromJSON(json['formativeCategory']),
        'subjectCategory': !exists(json, 'subjectCategory') ? undefined : IndicatorTypeEnumFromJSON(json['subjectCategory']),
        'credits': !exists(json, 'credits') ? undefined : json['credits'],
        'creditsIIS': !exists(json, 'creditsIIS') ? undefined : json['creditsIIS'],
        'creditsOE': !exists(json, 'creditsOE') ? undefined : json['creditsOE'],
        'planYear': !exists(json, 'planYear') ? undefined : json['planYear'],
        'courseWeeklyHours': !exists(json, 'courseWeeklyHours') ? undefined : json['courseWeeklyHours'],
        'labWeeklyHours': !exists(json, 'labWeeklyHours') ? undefined : json['labWeeklyHours'],
        'seminarWeeklyHours': !exists(json, 'seminarWeeklyHours') ? undefined : json['seminarWeeklyHours'],
        'projectWeeklyHours': !exists(json, 'projectWeeklyHours') ? undefined : json['projectWeeklyHours'],
        'labAtPartner': !exists(json, 'labAtPartner') ? undefined : json['labAtPartner'],
        'seminarAtPartner': !exists(json, 'seminarAtPartner') ? undefined : json['seminarAtPartner'],
        'projectAtPartner': !exists(json, 'projectAtPartner') ? undefined : json['projectAtPartner'],
        'practiceAtPartner': !exists(json, 'practiceAtPartner') ? undefined : json['practiceAtPartner'],
        'evaluationType': !exists(json, 'evaluationType') ? undefined : EvaluationTypeEnumFromJSON(json['evaluationType']),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'planDepartmentId': !exists(json, 'planDepartmentId') ? undefined : json['planDepartmentId'],
        'selfStudyHours': !exists(json, 'selfStudyHours') ? undefined : json['selfStudyHours'],
        'tutoringHours': !exists(json, 'tutoringHours') ? undefined : json['tutoringHours'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'laboratories': !exists(json, 'laboratories') ? undefined : (json['laboratories'] === null ? null : (json['laboratories'] as Array<any>).map(LaboratoryFromJSON)),
        'courseCoordinators': !exists(json, 'courseCoordinators') ? undefined : (json['courseCoordinators'] === null ? null : (json['courseCoordinators'] as Array<any>).map(AcademicUserNameDTOFromJSON)),
        'labCoordinators': !exists(json, 'labCoordinators') ? undefined : (json['labCoordinators'] === null ? null : (json['labCoordinators'] as Array<any>).map(AcademicUserNameDTOFromJSON)),
        'learnings': !exists(json, 'learnings') ? undefined : json['learnings'],
        'eafsgAreas': !exists(json, 'eafsgAreas') ? undefined : json['eafsgAreas'],
        'disciplineCategory': !exists(json, 'disciplineCategory') ? undefined : DisciplineCategoryEnumFromJSON(json['disciplineCategory']),
        'practiceTotalHours': !exists(json, 'practiceTotalHours') ? undefined : json['practiceTotalHours'],
    };
}

export function SubjectDTOToJSON(value?: SubjectDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'orderNumber': value.orderNumber,
        'code': value.code,
        'nameRO': value.nameRO,
        'nameEN': value.nameEN,
        'status': SubjectStatusEnumToJSON(value.status),
        'isPartiallySaved': value.isPartiallySaved,
        'formativeCategory': IndicatorTypeEnumToJSON(value.formativeCategory),
        'subjectCategory': IndicatorTypeEnumToJSON(value.subjectCategory),
        'credits': value.credits,
        'creditsIIS': value.creditsIIS,
        'creditsOE': value.creditsOE,
        'planYear': value.planYear,
        'courseWeeklyHours': value.courseWeeklyHours,
        'labWeeklyHours': value.labWeeklyHours,
        'seminarWeeklyHours': value.seminarWeeklyHours,
        'projectWeeklyHours': value.projectWeeklyHours,
        'labAtPartner': value.labAtPartner,
        'seminarAtPartner': value.seminarAtPartner,
        'projectAtPartner': value.projectAtPartner,
        'practiceAtPartner': value.practiceAtPartner,
        'evaluationType': EvaluationTypeEnumToJSON(value.evaluationType),
        'studyProgramId': value.studyProgramId,
        'departmentId': value.departmentId,
        'planDepartmentId': value.planDepartmentId,
        'selfStudyHours': value.selfStudyHours,
        'tutoringHours': value.tutoringHours,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'laboratories': value.laboratories === undefined ? undefined : (value.laboratories === null ? null : (value.laboratories as Array<any>).map(LaboratoryToJSON)),
        'courseCoordinators': value.courseCoordinators === undefined ? undefined : (value.courseCoordinators === null ? null : (value.courseCoordinators as Array<any>).map(AcademicUserNameDTOToJSON)),
        'labCoordinators': value.labCoordinators === undefined ? undefined : (value.labCoordinators === null ? null : (value.labCoordinators as Array<any>).map(AcademicUserNameDTOToJSON)),
        'learnings': value.learnings,
        'eafsgAreas': value.eafsgAreas,
        'disciplineCategory': DisciplineCategoryEnumToJSON(value.disciplineCategory),
        'practiceTotalHours': value.practiceTotalHours,
    };
}

